/* =====================================================================
   GOPSHOP – Produktseite
   <gop-gallery>   Galerie: Wischen (scroll-snap), Zähler, Punkte, Vorschaubilder, Pfeile,
                   Variantenbild (setActiveMedia wird von global.js/VariantSelects aufgerufen)
   <gop-lightbox>  Vollbild: Wischen, Pinch-Zoom, Doppeltippen, Klick-Zoom, Ziehen, Mausrad+Strg,
                   nach unten wischen = schließen, Pfeiltasten, Esc
   Kaufleiste      [data-gpp-bar] – Handy, erscheint wenn der Warenkorb-Button oben raus ist
   Extras          Bild-Farbfelder für Varianten, „Mehr lesen“, Auswahl neben der Option,
                   „Auf einen Blick“/Kaufleiste bei Variantenwechsel aktualisieren
   ===================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  /* Nur Medien innerhalb eines Bereichs anhalten (window.pauseAllMedia würde auch Videos anderer Bereiche stoppen) */
  function pauseMediaIn(root) {
    if (!root) return;
    root.querySelectorAll('video').forEach(function (v) {
      try { v.pause(); } catch (e) {}
    });
    root.querySelectorAll('.js-youtube').forEach(function (f) {
      if (f.contentWindow) f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
    root.querySelectorAll('.js-vimeo').forEach(function (f) {
      if (f.contentWindow) f.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    root.querySelectorAll('product-model').forEach(function (m) {
      if (m.modelViewerUI) m.modelViewerUI.pause();
    });
  }

  /* =====================================================================
     Galerie
     ===================================================================== */
  if (!customElements.get('gop-gallery')) {
    customElements.define(
      'gop-gallery',
      class GopGallery extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.track = this.querySelector('[data-gpg-track]');
          if (!this.track) return;
          this.thumbWrap = this.querySelector('[data-gpg-thumbs]');
          this.dotWrap = this.querySelector('[data-gpg-dots]');
          this.curEl = this.querySelector('[data-gpg-cur]');
          this.totEl = this.querySelector('[data-gpg-total]');
          this.prevBtn = this.querySelector('[data-gpg-prev]');
          this.nextBtn = this.querySelector('[data-gpg-next]');
          this.index = 0;
          this.raf = 0;
          this.collect();

          this.track.addEventListener(
            'scroll',
            () => {
              if (this.raf) return;
              this.raf = requestAnimationFrame(() => {
                this.raf = 0;
                this.sync();
              });
            },
            { passive: true }
          );

          this.addEventListener('click', (e) => {
            const thumb = e.target.closest('[data-gpg-thumb]');
            if (thumb) {
              this.goTo(this.indexOf(thumb.dataset.gpgThumb));
              return;
            }
            const opener = e.target.closest('[data-gpg-open]');
            if (opener) {
              this.openLightbox(opener);
              return;
            }
            if (e.target.closest('[data-gpg-prev]')) this.goTo(this.index - 1);
            if (e.target.closest('[data-gpg-next]')) this.goTo(this.index + 1);
          });

          this.track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') {
              e.preventDefault();
              this.goTo(this.index + 1);
            } else if (e.key === 'ArrowLeft') {
              e.preventDefault();
              this.goTo(this.index - 1);
            }
          });

          /* Nach Drehen/Größenänderung am aktuellen Bild bleiben */
          if ('ResizeObserver' in window) {
            let w = this.track.clientWidth;
            new ResizeObserver(() => {
              if (this.track.clientWidth === w) return;
              w = this.track.clientWidth;
              this.goTo(this.index, true);
            }).observe(this.track);
          }
        }

        collect() {
          this.slides = Array.from(this.track.children).filter((s) => !s.hidden);
          this.thumbs = this.thumbWrap
            ? Array.from(this.thumbWrap.querySelectorAll('[data-gpg-thumb]')).filter((t) => !t.hidden)
            : [];
          if (this.totEl) this.totEl.textContent = this.slides.length;
          if (this.dotWrap) {
            const dots = this.dotWrap.children;
            if (dots.length !== this.slides.length) {
              this.dotWrap.innerHTML = this.slides.map(() => '<span class="gpg__dot"></span>').join('');
            }
            this.dotWrap.hidden = this.slides.length < 2;
          }
          this.index = clamp(this.index, 0, Math.max(0, this.slides.length - 1));
          this.paint();
        }

        indexOf(mediaId) {
          return this.slides.findIndex((s) => s.dataset.mediaId === mediaId);
        }

        sync() {
          const w = this.track.clientWidth || 1;
          const i = clamp(Math.round(this.track.scrollLeft / w), 0, this.slides.length - 1);
          if (i === this.index) return;
          const old = this.slides[this.index];
          this.index = i;
          pauseMediaIn(old);
          this.paint();
        }

        paint() {
          const i = this.index;
          const n = this.slides.length;
          if (this.curEl) this.curEl.textContent = n ? i + 1 : 0;
          if (this.dotWrap) {
            Array.from(this.dotWrap.children).forEach((d, k) => d.classList.toggle('is-on', k === i));
          }
          if (this.prevBtn) this.prevBtn.disabled = i <= 0;
          if (this.nextBtn) this.nextBtn.disabled = i >= n - 1;
          const slide = this.slides[i];
          /* Tab-Reihenfolge: nur das sichtbare Bild ist per Tab erreichbar (die anderen per Pfeiltasten/Vorschaubild) */
          this.slides.forEach((s) => {
            s.querySelectorAll('.gpg__open, .deferred-media__poster').forEach((el) => {
              if (s === slide) el.removeAttribute('tabindex');
              else el.setAttribute('tabindex', '-1');
            });
          });
          if (!slide || !this.thumbWrap) return;
          let active = null;
          this.thumbWrap.querySelectorAll('[data-gpg-thumb]').forEach((t) => {
            const on = t.dataset.gpgThumb === slide.dataset.mediaId;
            if (on) {
              t.setAttribute('aria-current', 'true');
              active = t;
            } else {
              t.removeAttribute('aria-current');
            }
          });
          if (active) this.revealThumb(active);
        }

        /* Aktives Vorschaubild in seiner Leiste sichtbar machen – ohne die Seite zu scrollen */
        revealThumb(t) {
          const wrap = this.thumbWrap;
          const vertical = wrap.scrollHeight > wrap.clientHeight + 2 && wrap.scrollWidth <= wrap.clientWidth + 2;
          if (vertical) {
            const top = t.offsetTop - (wrap.clientHeight - t.offsetHeight) / 2;
            wrap.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
          } else if (wrap.scrollWidth > wrap.clientWidth + 2) {
            const left = t.offsetLeft - (wrap.clientWidth - t.offsetWidth) / 2;
            wrap.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }

        goTo(i, instant) {
          if (!this.slides.length) return;
          i = clamp(i, 0, this.slides.length - 1);
          const slide = this.slides[i];
          const old = this.slides[this.index];
          if (old && old !== slide) pauseMediaIn(old);
          this.index = i;
          this.track.scrollTo({ left: slide.offsetLeft, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
          this.paint();
        }

        /* Wird von global.js (VariantSelects.updateMedia) bei Variantenwechsel aufgerufen */
        setActiveMedia(mediaId) {
          if (this.hasAttribute('data-hide-variants')) {
            const target = this.track.querySelector('[data-media-id="' + mediaId + '"]');
            if (target && target.hasAttribute('data-variant-media')) {
              this.querySelectorAll('[data-variant-media]').forEach((el) => {
                const id = el.dataset.mediaId || el.dataset.gpgThumb;
                el.hidden = id !== mediaId;
              });
              this.collect();
            }
            const lb = this.lightbox();
            if (lb && lb.filterVariants) lb.filterVariants(mediaId);
          }
          const i = this.indexOf(mediaId);
          if (i > -1) this.goTo(i);
        }

        lightbox() {
          const id = this.getAttribute('data-lightbox');
          return id ? document.getElementById(id) : null;
        }

        openLightbox(opener) {
          const slide = opener.closest('[data-media-id]');
          const lb = this.lightbox();
          if (!slide || !lb || typeof lb.open !== 'function') return;
          lb.open(slide.dataset.mediaId, opener, (mediaId) => {
            const i = this.indexOf(mediaId);
            if (i > -1) this.goTo(i, true);
          });
        }
      }
    );
  }

  /* =====================================================================
     Vollbild mit Zoom
     ===================================================================== */
  if (!customElements.get('gop-lightbox')) {
    customElements.define(
      'gop-lightbox',
      class GopLightbox extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.dlg = this.querySelector('dialog');
          this.track = this.querySelector('[data-gpl-track]');
          if (!this.dlg || !this.track || typeof this.dlg.showModal !== 'function') return;
          this.curEl = this.querySelector('[data-gpl-cur]');
          this.totEl = this.querySelector('[data-gpl-total]');
          this.prevBtn = this.querySelector('[data-gpl-prev]');
          this.nextBtn = this.querySelector('[data-gpl-next]');
          this.s = 1;
          this.x = 0;
          this.y = 0;
          this.pts = new Map();
          this.index = 0;
          this.collect();

          this.querySelector('[data-gpl-close]').addEventListener('click', () => this.close());
          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));

          this.track.addEventListener(
            'scroll',
            () => {
              if (this.raf) return;
              this.raf = requestAnimationFrame(() => {
                this.raf = 0;
                const w = this.track.clientWidth || 1;
                const i = clamp(Math.round(this.track.scrollLeft / w), 0, this.slides.length - 1);
                if (i !== this.index) {
                  this.reset(false);
                  this.index = i;
                  this.paint();
                }
              });
            },
            { passive: true }
          );

          this.dlg.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') {
              e.preventDefault();
              this.go(this.index + 1);
            } else if (e.key === 'ArrowLeft') {
              e.preventDefault();
              this.go(this.index - 1);
            }
          });
          this.dlg.addEventListener('close', () => this.onClosed());
          /* Klick auf den dunklen Rand (außerhalb des Dialogs) – bei Vollbild selten, aber sicher */
          this.dlg.addEventListener('click', (e) => {
            if (e.target === this.dlg) this.close();
          });

          const t = this.track;
          t.addEventListener('pointerdown', (e) => this.onDown(e));
          t.addEventListener('pointermove', (e) => this.onMove(e));
          t.addEventListener('pointerup', (e) => this.onUp(e));
          t.addEventListener('pointercancel', (e) => this.onUp(e));
          t.addEventListener('wheel', (e) => this.onWheel(e), { passive: false });
          /* Safari-Gesten (Trackpad/iOS) nicht die ganze Seite zoomen lassen */
          t.addEventListener('gesturestart', (e) => e.preventDefault());
        }

        collect() {
          this.slides = Array.from(this.track.children).filter((s) => !s.hidden);
          if (this.totEl) this.totEl.textContent = this.slides.length;
        }

        filterVariants(mediaId) {
          const target = this.track.querySelector('[data-media-id="' + mediaId + '"]');
          if (!target || !target.hasAttribute('data-variant-media')) return;
          this.track.querySelectorAll('[data-variant-media]').forEach((el) => {
            el.hidden = el.dataset.mediaId !== mediaId;
          });
          this.collect();
        }

        open(mediaId, opener, onClose) {
          if (!this.dlg || this.dlg.open || !this.slides) return;
          this.opener = opener || null;
          this.onCloseCb = onClose || null;
          const i = Math.max(0, this.slides.findIndex((s) => s.dataset.mediaId === mediaId));
          this.dlg.classList.remove('is-used', 'is-zoomed');
          this.dlg.showModal();
          document.documentElement.classList.add('gpl-lock');
          this.index = i;
          this.reset(false);
          this.track.style.scrollBehavior = 'auto';
          this.track.scrollLeft = this.slides[i] ? this.slides[i].offsetLeft : 0;
          this.track.style.scrollBehavior = '';
          this.paint();
        }

        close() {
          if (this.dlg.open) this.dlg.close();
        }

        onClosed() {
          document.documentElement.classList.remove('gpl-lock');
          const slide = this.slides[this.index];
          this.reset(false);
          const z = this.zoomEl();
          if (z) z.style.opacity = '';
          if (this.onCloseCb && slide) this.onCloseCb(slide.dataset.mediaId);
          if (this.opener && document.contains(this.opener)) {
            try { this.opener.focus({ preventScroll: true }); } catch (e) { this.opener.focus(); }
          }
        }

        go(i) {
          if (!this.slides.length) return;
          i = clamp(i, 0, this.slides.length - 1);
          if (i === this.index) return;
          this.reset(false);
          this.index = i;
          this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          this.paint();
        }

        paint() {
          if (this.curEl) this.curEl.textContent = this.index + 1;
          if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
          if (this.nextBtn) this.nextBtn.disabled = this.index >= this.slides.length - 1;
        }

        slide() {
          return this.slides[this.index];
        }

        zoomEl() {
          const s = this.slide();
          return s ? s.querySelector('.gpl__zoom') : null;
        }

        rel(clientX, clientY) {
          const r = this.slide().getBoundingClientRect();
          return { x: clientX - r.left, y: clientY - r.top };
        }

        bound() {
          const s = this.slide();
          const w = s.clientWidth;
          const h = s.clientHeight;
          this.x = clamp(this.x, w - w * this.s, 0);
          this.y = clamp(this.y, h - h * this.s, 0);
        }

        apply(anim, free) {
          const z = this.zoomEl();
          if (!z) return;
          if (!free) this.bound();
          z.classList.toggle('is-anim', !!anim && !reduceMotion);
          z.style.transform = this.s === 1 && this.x === 0 && this.y === 0 ? '' : 'translate3d(' + this.x + 'px,' + this.y + 'px,0) scale(' + this.s + ')';
          this.dlg.classList.toggle('is-zoomed', this.s > 1.01);
          if (this.s > 1.2) {
            /* schärferes Bild nachladen, sobald gezoomt wird */
            const img = z.querySelector('img');
            if (img && img.sizes !== '260vw') img.sizes = '260vw';
          }
        }

        reset(anim) {
          this.s = 1;
          this.x = 0;
          this.y = 0;
          this.pinch = null;
          this.drag = null;
          this.pts.clear();
          this.apply(anim);
        }

        zoomAt(p, s, anim) {
          s = clamp(s, 1, 5);
          const k = s / this.s;
          this.x = p.x - (p.x - this.x) * k;
          this.y = p.y - (p.y - this.y) * k;
          this.s = s;
          this.apply(anim);
        }

        used() {
          this.dlg.classList.add('is-used');
        }

        onDown(e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (!this.slide()) return;
          this.pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
          if (this.pts.size === 2) {
            const p = Array.from(this.pts.values());
            const m = this.rel((p[0].x + p[1].x) / 2, (p[0].y + p[1].y) / 2);
            this.pinch = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, s: this.s, x: this.x, y: this.y, m: m };
            this.drag = null;
            this.used();
          } else if (this.pts.size === 1) {
            this.drag = { x0: e.clientX, y0: e.clientY, tx: this.x, ty: this.y, t: performance.now(), moved: false, axis: '' };
            if (this.s > 1 || e.pointerType === 'mouse') {
              try { this.track.setPointerCapture(e.pointerId); } catch (err) {}
            }
          }
        }

        onMove(e) {
          if (!this.pts.has(e.pointerId)) return;
          this.pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
          if (this.pinch && this.pts.size >= 2) {
            e.preventDefault();
            const p = Array.from(this.pts.values());
            const d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
            const m = this.rel((p[0].x + p[1].x) / 2, (p[0].y + p[1].y) / 2);
            const s = clamp((this.pinch.s * d) / this.pinch.d, 0.85, 5);
            const k = s / this.pinch.s;
            this.s = s;
            this.x = m.x - (this.pinch.m.x - this.pinch.x) * k;
            this.y = m.y - (this.pinch.m.y - this.pinch.y) * k;
            this.apply(false, true);
            return;
          }
          const dr = this.drag;
          if (!dr) return;
          const dx = e.clientX - dr.x0;
          const dy = e.clientY - dr.y0;
          if (!dr.moved && Math.abs(dx) + Math.abs(dy) > 6) {
            dr.moved = true;
            dr.axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
          }
          if (!dr.moved) return;
          if (this.s > 1.01) {
            this.x = dr.tx + dx;
            this.y = dr.ty + dy;
            this.apply(false);
          } else if (dr.axis === 'y' && e.pointerType !== 'mouse') {
            /* nach unten wischen = schließen (Bild folgt dem Finger) */
            const z = this.zoomEl();
            if (z) {
              z.classList.remove('is-anim');
              z.style.transform = 'translate3d(0,' + Math.max(0, dy) + 'px,0)';
              z.style.opacity = String(clamp(1 - Math.max(0, dy) / 400, 0.35, 1));
            }
          }
        }

        onUp(e) {
          if (!this.pts.has(e.pointerId)) return;
          this.pts.delete(e.pointerId);
          if (this.pinch) {
            if (this.pts.size < 2) {
              this.pinch = null;
              if (this.s < 1.08) this.reset(true);
              else this.apply(true);
              if (this.pts.size === 1) {
                const p = Array.from(this.pts.values())[0];
                this.drag = { x0: p.x, y0: p.y, tx: this.x, ty: this.y, t: performance.now(), moved: true, axis: 'x' };
              } else {
                this.drag = null;
              }
            }
            return;
          }
          const dr = this.drag;
          this.drag = null;
          if (!dr) return;
          const dy = e.clientY - dr.y0;
          if (this.s <= 1.01 && dr.axis === 'y' && e.pointerType !== 'mouse') {
            const z = this.zoomEl();
            if (e.type !== 'pointercancel' && dy > 110) {
              this.close();
              return;
            }
            if (z) {
              z.classList.add('is-anim');
              z.style.transform = '';
              z.style.opacity = '';
            }
            return;
          }
          if (e.type === 'pointercancel') return;
          if (!dr.moved && performance.now() - dr.t < 350) this.tap(e);
          else if (this.s > 1.01) this.apply(true);
        }

        tap(e) {
          const p = this.rel(e.clientX, e.clientY);
          if (e.pointerType === 'mouse') {
            this.used();
            if (this.s > 1.01) this.reset(true);
            else this.zoomAt(p, 2.5, true);
            return;
          }
          const now = performance.now();
          const last = this.lastTap;
          if (last && now - last.t < 320 && Math.hypot(e.clientX - last.x, e.clientY - last.y) < 36) {
            this.lastTap = null;
            this.used();
            if (this.s > 1.01) this.reset(true);
            else this.zoomAt(p, 2.5, true);
          } else {
            this.lastTap = { t: now, x: e.clientX, y: e.clientY };
          }
        }

        onWheel(e) {
          if (!this.slide()) return;
          if (!e.ctrlKey && this.s <= 1.01) return;
          e.preventDefault();
          this.used();
          if (e.ctrlKey) {
            const f = Math.exp(-e.deltaY * 0.01);
            this.zoomAt(this.rel(e.clientX, e.clientY), this.s * f, false);
            if (this.s < 1.02) this.reset(false);
          } else {
            this.x -= e.deltaX;
            this.y -= e.deltaY;
            this.apply(false);
          }
        }
      }
    );
  }

  /* =====================================================================
     Handy-Kaufleiste
     ===================================================================== */
  function initBar(bar) {
    if (bar.dataset.gppReady) return;
    bar.dataset.gppReady = '1';
    const sid = bar.dataset.section;
    const main = document.getElementById('ProductSubmitButton-' + sid);
    const btn = bar.querySelector('[data-gpp-bar-add]');
    if (!main || !btn || !('IntersectionObserver' in window)) {
      bar.remove();
      return;
    }
    const label = btn.querySelector('span');
    const shortLabel = label ? label.textContent.trim() : '';

    /* Zustand des echten Buttons spiegeln: gesperrt → dessen Text (z. B. „Ausverkauft“), sonst kurzer Text */
    const mirror = () => {
      const off = main.disabled || main.getAttribute('aria-disabled') === 'true';
      btn.disabled = off;
      btn.classList.toggle('loading', main.classList.contains('loading'));
      if (!label) return;
      const t = main.querySelector('span');
      const text = off && !main.classList.contains('loading') && t ? t.textContent.trim() : '';
      label.textContent = text || shortLabel;
    };
    mirror();
    new MutationObserver(mirror).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });

    btn.addEventListener('click', () => {
      if (!main.disabled) main.click();
    });

    const show = (on) => {
      bar.classList.toggle('is-on', on);
      if (on) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
      document.body.classList.toggle('gpp-bar-on', on);
    };

    new IntersectionObserver(
      (entries) => {
        const en = entries[0];
        show(!en.isIntersecting && en.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    ).observe(main);

    /* 7.0: IntersectionObserver meldet nichts, wenn der Button in einem Sprung von unterhalb nach oberhalb
       des Bildschirms wandert (schnelles Wischen, Sprunglink, wiederhergestellte Scroll-Position).
       Darum zusätzlich beim Scrollen prüfen – gedrosselt per requestAnimationFrame, passiv. */
    let ticking = false;
    const check = () => {
      ticking = false;
      const r = main.getBoundingClientRect();
      const on = r.bottom < 0;
      if (on !== bar.classList.contains('is-on')) show(on);
    };
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(check);
      },
      { passive: true }
    );
    check();
  }

  /* =====================================================================
     Varianten: Bild-Kacheln (wie Swatch-Apps) + gewählter Wert neben dem Namen
     Kacheln erscheinen automatisch, wenn eine Option (z. B. „Modell“, „Farbe“, „Duft“)
     Variantenbilder hat: Handy 4 Spalten, Desktop mehr. Viele Werte → Suche + „Alle anzeigen“.
     Größen-Optionen bleiben Pillen.
     ===================================================================== */
  const EN = /^en/i.test(document.documentElement.lang || '');
  const T = EN
    ? { all: (n) => 'Show all ' + n, less: 'Show less', find: 'Search…', none: 'Nothing found', out: 'Sold out' }
    : { all: (n) => 'Alle ' + n + ' anzeigen', less: 'Weniger anzeigen', find: 'Suchen…', none: 'Nichts gefunden', out: 'Ausverkauft' };
  const SIZE_RX = /gr(ö|oe)(ß|ss)e|size|taille|tama|menge|volumen|anzahl|quantity|länge|length|breite|width|^ml$|^inhalt \(ml\)$/i;
  const TILE_RX = /modell|model|modelo|mod[eè]le|duft|scent|fragrance|parfum|design|style|stil|variante|variant|motiv|sorte|edition|ausf[üu]hrung|typ|type|version|farbe|color|colou?r|couleur|colore|kollektion|collection|look/i;
  const SZ_RX = /^(.+?)\s*[-–|·]\s*(\d+(?:[.,]\d+)?\s?(?:ml|g|cl|l|oz|mm|cm))$/i;
  const norm = (t) =>
    String(t || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  const imgUrl = (src, w) => {
    if (!src) return '';
    const u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };
  const initials = (v) =>
    String(v)
      .replace(/\(.*?\)/g, ' ')
      .split(/[\s\-–/]+/)
      .filter((w) => /[a-z0-9]/i.test(w) && !/^\d+ ?ml$/i.test(w))
      .slice(0, 2)
      .map((w) => w[0].toUpperCase())
      .join('');

  /* Ein großes Vorschaubild beim Überfahren (nur mit Maus) */
  let pop = null;
  function showPop(lab, src, name) {
    if (!src || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (!pop) {
      pop = document.createElement('div');
      pop.className = 'gpp-tpop';
      pop.setAttribute('aria-hidden', 'true');
      pop.innerHTML = '<img alt="" width="240" height="240" decoding="async"><span></span>';
      document.body.appendChild(pop);
    }
    const im = pop.querySelector('img');
    const big = imgUrl(src, 480);
    if (im.getAttribute('src') !== big) im.src = big;
    pop.querySelector('span').textContent = name;
    const r = lab.getBoundingClientRect();
    const w = 220;
    const left = Math.max(8, Math.min(window.innerWidth - w - 8, r.left + r.width / 2 - w / 2));
    const above = r.top > 300;
    pop.style.left = left + 'px';
    pop.style.top = (above ? r.top - 12 : r.bottom + 12) + 'px';
    pop.classList.toggle('is-below', !above);
    pop.classList.add('is-on');
  }
  function hidePop() {
    if (pop) pop.classList.remove('is-on');
  }
  window.addEventListener('scroll', hidePop, { passive: true });

  function buildTiles(fs, idx, variants, imgs) {
    const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
    const legend = fs.querySelector('legend');
    const grid = document.createElement('div');
    grid.className = 'gpp-tiles';
    const sizes = new Set(inputs.map((i) => (i.value.match(SZ_RX) || [])[2]).filter(Boolean).map((t) => t.replace(/\s/g, '').toLowerCase()));
    const multiSize = sizes.size > 1;
    inputs.forEach((input, k) => {
      const lab = input.id ? fs.querySelector('label[for="' + input.id + '"]') : null;
      if (!lab) return;
      const media = document.createElement('span');
      media.className = 'gpp-tile__media';
      const src = imgs[k];
      if (src) {
        const img = document.createElement('img');
        img.alt = '';
        img.width = 160;
        img.height = 160;
        img.loading = k < 12 ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.sizes = '(min-width: 990px) 110px, 24vw';
        img.srcset = [160, 240, 360].map((w) => imgUrl(src, w) + ' ' + w + 'w').join(', ');
        img.src = imgUrl(src, 240);
        img.addEventListener('load', () => media.classList.add('is-in'), { once: true });
        if (img.complete) media.classList.add('is-in');
        media.appendChild(img);
      } else {
        media.classList.add('is-mono', 'is-in');
        media.setAttribute('data-mono', initials(input.value) || '•');
      }
      const name = document.createElement('span');
      name.className = 'gpp-tile__name';
      while (lab.firstChild) name.appendChild(lab.firstChild);
      let sub = null;
      /* „Name (Old Version) - 100ML“ → Name, kleine Zusatzzeile, Größe als Etikett aufs Bild (nur wenn Größen variieren) */
      if (name.firstChild && name.firstChild.nodeType === 3) {
        let main = input.value;
        const sz = main.match(SZ_RX);
        if (sz) {
          main = sz[1];
          if (multiSize) {
            const tag = document.createElement('span');
            tag.className = 'gpp-tile__tag';
            tag.setAttribute('aria-hidden', 'true');
            tag.textContent = sz[2].replace(/\s/g, '').toUpperCase();
            media.appendChild(tag);
          }
        }
        const par = main.match(/^(.*?)\s*\((.+?)\)\s*(.*)$/);
        name.firstChild.textContent = par ? (par[1] + ' ' + par[3]).trim() : main;
        if (par) {
          sub = document.createElement('span');
          sub.className = 'gpp-tile__sub';
          sub.setAttribute('aria-hidden', 'true');
          sub.textContent = par[2];
        }
      }
      const check = document.createElement('span');
      check.className = 'gpp-tile__check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = '<svg viewBox="0 0 16 16" width="10" height="10"><path d="M3.5 8.4l2.9 2.9 6.1-6.6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      const out = document.createElement('span');
      out.className = 'gpp-tile__out';
      out.setAttribute('aria-hidden', 'true');
      out.textContent = T.out;
      lab.classList.add('gpp-tile');
      lab.title = input.value;
      media.appendChild(out);
      lab.append(media, check, name);
      if (sub) lab.appendChild(sub);
      lab.addEventListener('mouseenter', () => showPop(lab, src, input.value));
      lab.addEventListener('mouseleave', hidePop);
      grid.append(input, lab);
    });
    fs.appendChild(grid);
    fs.classList.add('gpp-tiles-fs');
    hidePop();

    const n = inputs.length;
    if (legend) {
      const cnt = document.createElement('span');
      cnt.className = 'gpp-cnt';
      cnt.textContent = n;
      legend.insertBefore(cnt, legend.querySelector('.gpp-sel'));
    }

    /* Viele Werte: Suche + auf 2 Reihen einklappen */
    let query = '';
    let open = false;
    let search = null;
    let empty = null;
    const more = document.createElement('button');
    more.type = 'button';
    more.className = 'gpp-tmore';
    more.hidden = true;
    fs.appendChild(more);
    if (n > 12) {
      const wrap = document.createElement('div');
      wrap.className = 'gpp-tsearch';
      wrap.innerHTML =
        '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><circle cx="9" cy="9" r="6" fill="none" stroke="currentColor" stroke-width="2"/><path d="M13.5 13.5L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      search = document.createElement('input');
      search.type = 'search';
      search.autocomplete = 'off';
      search.enterKeyHint = 'search';
      search.placeholder = T.find;
      search.setAttribute('aria-label', (legend ? legend.firstChild.textContent.trim() + ' ' : '') + T.find);
      wrap.appendChild(search);
      fs.insertBefore(wrap, grid);
      empty = document.createElement('p');
      empty.className = 'gpp-tempty';
      empty.textContent = T.none;
      empty.hidden = true;
      fs.insertBefore(empty, more);
      /* Tippen in der Suche darf keinen Variantenwechsel auslösen */
      ['change', 'input', 'keydown'].forEach((ev) =>
        search.addEventListener(ev, (e) => {
          e.stopPropagation();
          if (ev === 'keydown' && e.key === 'Enter') e.preventDefault();
          if (ev === 'input') {
            query = norm(search.value);
            layout();
          }
        })
      );
    }
    const cols = () => {
      const t = getComputedStyle(grid).gridTemplateColumns;
      return Math.max(1, t && t !== 'none' ? t.split(' ').length : 4);
    };
    function layout() {
      const labs = Array.from(grid.querySelectorAll('.gpp-tile'));
      const limit = cols() * 2;
      const collapse = !open && !query && n > limit + 1;
      let shown = 0;
      labs.forEach((lab, k) => {
        const input = document.getElementById(lab.htmlFor);
        let vis = true;
        if (query) vis = norm(input && input.value).indexOf(query) > -1;
        else if (collapse) vis = k < limit || (input && input.checked);
        /* neu eingeblendete Kacheln kurz nacheinander hereinfliegen lassen */
        if (vis && lab.classList.contains('is-hid') && !reduceMotion) {
          lab.style.setProperty('--gpp-d', Math.min(shown, 24) * 18 + 'ms');
          lab.classList.remove('is-pop');
          void lab.offsetWidth;
          lab.classList.add('is-pop');
        }
        lab.classList.toggle('is-hid', !vis);
        if (vis) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      more.hidden = !!query || n <= limit + 1;
      more.textContent = open ? T.less : T.all(n);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    more.addEventListener('click', () => {
      open = !open;
      layout();
      if (!open) fs.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    if ('ResizeObserver' in window) {
      let lastCols = 0;
      new ResizeObserver(() => {
        const c = cols();
        if (c !== lastCols) {
          lastCols = c;
          layout();
        }
      }).observe(grid);
    }
    layout();
    return { idx, layout, grid };
  }

  function initVariantUi(picker) {
    if (picker.dataset.gppReady) return;
    picker.dataset.gppReady = '1';
    let variants = [];
    try {
      variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent) || [];
    } catch (e) {
      variants = [];
    }
    const sets = Array.from(picker.querySelectorAll('fieldset.product-form__input'));
    const tiles = [];

    sets.forEach((fs, idx) => {
      const legend = fs.querySelector('legend');
      if (legend && !legend.querySelector('.gpp-sel')) {
        const sel = document.createElement('span');
        sel.className = 'gpp-sel';
        legend.appendChild(sel);
      }
      /* 7.4: Mystery-Boxen – Options-Name einheitlich „Inhalt“ (nur Anzeige; z. B. „MODEL“ bei der Big-Box) */
      if (legend && legend.firstChild && sets.length === 1 && document.querySelector('.gpp .gmt')) {
        legend.firstChild.textContent = EN ? 'Contents' : 'Inhalt';
      }
      const name = legend ? legend.firstChild.textContent.trim() : '';
      if (SIZE_RX.test(name)) {
        /* „Größentabelle“-Link neben der Größen-Option (öffnet „Größe & Passform“) */
        const sec = picker.closest('section') || document;
        const guide = sec.querySelector('[data-gpp-size]');
        if (guide && legend && !legend.querySelector('.gpp-sizelink')) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'gpp-sizelink';
          b.innerHTML =
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.5 8.5 3 21 15.5 15.5 21z"/><path d="m7 7 2 2M10 4.5l1.5 1.5M12.5 9.5l2 2M15 7l1.5 1.5M17.5 14.5 19 16"/></svg>' +
            (EN ? 'Size guide' : 'Größentabelle');
          b.addEventListener('click', () => {
            guide.open = true;
            guide.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
          });
          legend.appendChild(b);
        }
        return;
      }
      const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
      if (inputs.length < 2) return;
      const imgs = inputs.map((input) => {
        const v = variants.find((vr) => vr.options && vr.options[idx] === input.value && vr.featured_image);
        return v ? v.featured_image.src : null;
      });
      const withImg = imgs.filter(Boolean);
      const unique = new Set(withImg);
      /* Bekannter Name (Modell, Farbe …, Groß/klein egal): ab 40 % mit Bild, auch wenn die Bilder gleich sind.
         Unbekannter Name: ab 60 % mit Bild. In beiden Fällen mind. 2 verschiedene Bilder (7.4). */
      const known = TILE_RX.test(name);
      if (!withImg.length || withImg.length < Math.ceil(inputs.length * (known ? 0.4 : 0.6))) return;
      /* 7.4: alle Variantenbilder gleich → Kacheln zeigen nichts Neues → Pillen bleiben */
      if (unique.size < 2) return;
      tiles.push(buildTiles(fs, idx, variants, imgs));
    });

    const update = () => {
      const sel = sets.map((fs) => {
        const c = fs.querySelector('input[type="radio"]:checked');
        const out = fs.querySelector('.gpp-sel');
        if (out) out.textContent = c ? c.value : '';
        return c ? c.value : null;
      });
      /* Kachel ausverkauft, wenn es mit den übrigen gewählten Optionen keine lieferbare Variante gibt */
      tiles.forEach((t) => {
        t.grid.querySelectorAll('input[type="radio"]').forEach((input) => {
          const ok = variants.some(
            (v) => v.available && v.options && v.options.every((o, i) => (i === t.idx ? o === input.value : sel[i] == null || o === sel[i]))
          );
          const lab = input.id ? t.grid.querySelector('label[for="' + input.id + '"]') : null;
          if (lab) lab.classList.toggle('is-out', !ok);
        });
        t.layout();
      });
    };
    update();
    picker.addEventListener('change', update);
  }

  /* =====================================================================
     Beschreibung: lange Texte kürzen mit „Mehr lesen“
     ===================================================================== */
  function initDesc(desc) {
    if (desc.dataset.gppReady) return;
    desc.dataset.gppReady = '1';
    const btn = desc.parentElement ? desc.parentElement.querySelector('[data-gpp-more]') : null;
    if (!btn) return;
    const check = () => {
      if (desc.classList.contains('is-open')) return;
      if (desc.scrollHeight > 330) {
        desc.classList.add('is-clamped');
        btn.hidden = false;
      }
    };
    check();
    btn.addEventListener('click', () => {
      const open = desc.classList.toggle('is-open');
      desc.classList.toggle('is-clamped', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      if (!open) desc.closest('details').scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* =====================================================================
     Variantenwechsel: „Auf einen Blick“ + Kaufleiste aus der neuen Section-Antwort übernehmen
     ===================================================================== */
  function listenVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;
      ['GopFacts-', 'GopBarPrice-', 'GopBarVar-'].forEach((prefix) => {
        const target = document.getElementById(prefix + data.sectionId);
        const source = data.html.getElementById(prefix + data.sectionId);
        if (target && source) target.innerHTML = source.innerHTML;
      });
      /* Kaufleiste: Bild der gewählten Variante */
      const barSel = '#GopBar-' + data.sectionId + ' .gpp-bar__img';
      const barImg = document.querySelector(barSel);
      const newImg = data.html.querySelector(barSel);
      if (barImg && newImg && newImg.getAttribute('src') !== barImg.getAttribute('src')) {
        ['srcset', 'src'].forEach((a) => {
          const v = newImg.getAttribute(a);
          if (v) barImg.setAttribute(a, v);
          else barImg.removeAttribute(a);
        });
      }
    });
  }

  /* =====================================================================
     7.0: Gopa-Knopf (unten rechts, fixiert) weicht am Handy aus, solange Titelkarte, Box-Wahl,
     Varianten oder der Kaufen-Knopf im unteren Bildschirmbereich liegen – so verdeckt er nichts Wichtiges.
     Gleiche Klasse wie beim Neuheiten-Karussell (is-shy, gop-2.css).
     ===================================================================== */
  function initShy() {
    const mascot = document.querySelector('[data-gop-mascot]');
    if (!mascot || !('IntersectionObserver' in window) || !window.matchMedia) return;
    const targets = document.querySelectorAll('.gpp .gpp-head, .gpp .gmt, .gpp variant-selects, .gpp variant-radios, .gpp .product-form__buttons, .gpp .gmt-up');
    if (!targets.length) return;
    const mq = window.matchMedia('(max-width: 749px)');
    const inZone = new Set();
    const apply = () => mascot.classList.toggle('is-shy', mq.matches && inZone.size > 0);
    /* nur das untere Fünftel des Bildschirms zählt – dort sitzt der Knopf */
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => (en.isIntersecting ? inZone.add(en.target) : inZone.delete(en.target)));
        apply();
      },
      { rootMargin: '-80% 0px 0px 0px' }
    );
    targets.forEach((t) => io.observe(t));
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  function init(scope) {
    const root = scope || document;
    if (!scope) initShy();
    root.querySelectorAll('[data-gpp-bar]').forEach(initBar);
    root.querySelectorAll('.gpp variant-radios').forEach(initVariantUi);
    root.querySelectorAll('[data-gpp-desc]').forEach(initDesc);
  }

  init();
  listenVariantChange();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
